import React, { Component, useState, useEffect } from 'react';
import Select from 'react-select';
import * as ReactDOM from 'react-dom';
import PropTypes from 'prop-types';
import { debug } from 'util';

import Configdata from './Defaultdata';
import './home.css';
import { getmessage,setuserpoints } from './Dynamictable';
import Applysaleexecutive from './Applysaleexecutive';
import axios from 'axios';
export default class Offers extends Component {
    state = {
        name: "World",
        type: "1",
        Phone: null,
        msg: "",
        typeoption: null,
        expoption: null,
        catoption: null,
        bindopt: null,
        isVisible: true,
        resm: null,
        url: "",
        walk: "",
        citywalk:"",
	reffercode:"",
        tpb: null,
        opening: [{}]
    };

    
  
    setserverurl() {
        debugger;
        const appurl = Configdata.srvurl;
       
        this.setState({ url: appurl });
    }
     saleexecutivedetails(e:any) {
        const sales = <Applysaleexecutive />
             
                var maindiv = document.getElementById('container') as HTMLElement;
		const Pdivr = document.getElementById('profilediv') as HTMLElement;
		ReactDOM.render(sales,maindiv);
		maindiv.style.display = 'block';
		Pdivr.style.display = 'none';
		
		e.preventDefault();


    }

    componentDidMount() {
        debugger;
     
        //this.Homehitcount();
        this.setserverurl();
       
     
    }
    
 updatepoints(e: any){
	try {
		getmessage('On Process Please wait.....','');
		
          	const offerpoints = 50 * (Math.floor(Math.random()*10));	
		
                const response = axios.post(Configdata.srvurl + '/insertoffer2', {
    		
    		procode: localStorage.getItem("id"),
		points:offerpoints
              
  		}, {
    		    headers: {
      				'Content-Type': 'application/json'
    			      }
  			}
		);
	      
                if(response){
		 response.then((result:any) => {
		const usercd = result.data;
		if(usercd == null || usercd == 'NA')
		getmessage('Current can not Process','');
		else{
		const getpoints = 'You won ' + offerpoints + ' Points';
		setuserpoints(usercd);
		getmessage(getpoints,'');
	        } 
	        });		
              }
		
	   
          }
        catch (e) {
           // debugger;
		//wrongmsg();
        }
	e.preventDefault()

 };
setreffer(code:any){

try {
		getmessage('On Process Please wait.....','');
		const rfcode =  code ;
		const offerpoints = 50;
		const token =  localStorage.getItem("id") ;
		
                const response = axios.post(Configdata.srvurl + '/insertoffer3', {
    		
    		procode: token,
		urcode:rfcode
              
  		}, {
    		    headers: {
      				'Content-Type': 'application/json'
    			      }
  			}
		);
	      
                if(response){
		 response.then((result:any) => {
		const usercd = result.data;
		
		if(usercd == null || usercd == 'NA')
		getmessage('Somthing went Wrong','');
		
		else{
		

		const getpoints = 'You won ' + offerpoints + ' Points';
		setuserpoints(usercd);
		getmessage(getpoints,'');
	        } 
	        });		
              }
		
	   
          }
        catch (e) {
           // debugger;
		//wrongmsg();
        }


}
setuserreffer(e:any){
const code = this.state.reffercode;
 if(code == ""){
	getmessage('Please enter referal user code','');

  }
  else{
    this.setreffer(code);
  }
  		
  e.preventDefault()
};

textboxChange(event: any) {
         const id = event.target.id;
	const elvalue = event.target.value;
	//alert(id);
        if(id == 'txtrfcode'){
        
	 this.setState({ reffercode: elvalue });
	}
	
	
   };
 render() {

   
     return (

         <form>
	<div style={{width:'99vw'}} id="homemain">
	 
	<div>
		<div className="centerdiv" style={{width:'99vw'}}>
		 <table style={{width:'99vw'}}>
		   <tr>
			<td className="td-txtcenter" style={{backgroundColor:'#dedede',color:'#ffffff'}}>
			OFFERS
			</td>
		   </tr>

		   <tr>
			<td style={{paddingTop:'30px'}}>
			Check your luck by click on the luck buttom where hidden from 50 to 500 points. As per your luck you will get the points
			</td>
		   </tr>
	         <tr>
			<td  className="td-txtcenter">
			 <button id="btnluck" onClick={e => this.updatepoints(e)}>TEST YOUR LUCK</button>
			</td>
		   </tr>
		   <tr>
			<td style={{paddingTop:'30px'}}>
			Refere user and get 50 points(one time refere)
			</td>
		   </tr>
	           <tr>
			<td style={{paddingTop:'30px'}}>
			<div>	
			 <div className="searchtype" id="referalusercode" style={{width:'84%'}}>
			  <input placeholder="Enter user Code"  onChange={e => this.textboxChange(e)} id="txtrfcode" type="text" style={{width:'90%'}}/>
	
			 </div>
 
		       </div>

			</td>
		   </tr>

		    <tr>
			<td className="td-txtcenter">
			  <button id="btnluck" onClick={e => this.setuserreffer(e)}>REFER USER</button>

			</td>
		   </tr>
		    <tr>
			<td className="td-txtcenter">
			<div style={{width:'98%'}}>
			 by click the bellow button get the details of the Sales Executive commissions and achievment  
			</div>
			 <div style={{width:'98%'}}>
			  <button id="btnluck" onClick={e => this.saleexecutivedetails(e)}>Apply Sales Executive</button>
			</div>
			</td>
		   </tr>

		</table>
		</div>
	</div>
        
	</div>
   	</form>
    
   
      );
}
};

